import { queryBuyerCodeList } from '@/api/ar'
import BaseCategory from '../BaseCategory'
import _ from 'lodash'

export default class ArCustomerCategory implements BaseCategory {
  async getOptions () {
    const result = await queryBuyerCodeList()
    return _.map(result, item => {
      return {
        label: _.get(item, 'buyerName'),
        value: _.get(item, 'buyerCode')
      }
    })
  }
}
